import React, { useEffect, useState, useRef } from 'react';
import './bottomCard.css';
import html2canvas from 'html2canvas';
import {utilWebView} from "./util";
import { tutorEndConfig } from "../tutorEndConfig";

const BottomCard = ({show, image, imageBlob, setDrawer, data}) => {
	const [base64Data, setBase64Data] = useState("");

	const copyText =
		data &&
`${tutorEndConfig.text?.certificate_share_message_prefix || "Hey!🙏 Look at my achievements during Classplus's 7th Birthday Sale 🎂 Yours "}${data?.certificateData?.heading}`;

	useEffect(() => {
	}, [data]);

	const handleConvertToBlob = () => {
		if (!imageBlob) {
			console.error("imageBlob is not defined or invalid.");
			return;
		}
		const container = document.getElementById(imageBlob);
		if (!container) {
			console.error(`Element with class "${imageBlob}" not found.`);
			return;
		}
		html2canvas(container, { scrollY: -window.scrollY, allowTaint: true, useCORS: true }).then(function (canvas) {
			canvas.toBlob((blob) => {
				var reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onloadend = function () {
					var base64data = reader.result;
					base64data = btoa(base64data);
					setBase64Data(base64data);
				};
			});
		});
	}

	const copyTextToClipboard = (text) => {
		if (!text) {
			console.error("No text to copy!");
			return;
		}
		try {
			const elem = document.createElement('textarea');
			document.body.appendChild(elem);
			elem.value = text;
			elem.select();
			document.execCommand('copy');
			document.body.removeChild(elem);
		}
		catch (error) {
			console.error("Failed to copy text:", error);
		}
	};

	const shareLinkAppHandler = () => {
		var container = document.getElementById(imageBlob);
		container.style.width = container.clientWidth + "px"
		container.style.height = container.clientHeight + "px"

		copyTextToClipboard(copyText)
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		html2canvas(container,{scale:5}).then(function (canvas) {
			canvas.toBlob((blob) => {
				var reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onloadend = function () {
					var base64data = reader.result;
					base64data = btoa(base64data);
					const files = [new File([blob], 'poster.png', { type: blob.type })];
					const shareData = {
						text: copyText,
						title: '',
						files,
					};

					let DeepLink = {
						screen: "UTIL_SHARE_IMAGE_BASE64",
						paramOne: `${base64data}`,
						paramTwo: `${copyText}`,
						paramTracking: "CertificateShared",
						paramThree: "",
						paramSource: "",
					};
					if (window && window.mobile && window.mobile.exceuteDeeplink) {
						window.mobile.exceuteDeeplink(JSON.stringify(DeepLink));
						return;
					}

					if (
						window &&
						window.webkit &&
						window.webkit.messageHandlers &&
						window.webkit.messageHandlers.onDeeplinkExecuted
					) {
						window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
							`UTIL_SHARE_IMAGE_BASE64,${base64data}`
						);
					}
				};
			});
		});
	};

	// function downloadBoardImage() {
	// 	var container = document.getElementById(imageBlob);
	// 	document.body.scrollTop = 0; // For Safari
	// 	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	//
	// 	html2canvas(container, {scale:5},{ allowTaint: true }).then(function (canvas) {
	// 		canvas.toBlob((blob) => {
	// 			var reader = new FileReader();
	// 			reader.readAsDataURL(blob);
	// 			reader.onloadend = function () {
	// 				var base64data = reader.result;
	// 				base64data = btoa(base64data);
	//
	// 				if (window && window.mobile && window.mobile.onDeeplinkExecuted) {
	// 					window.mobile.onDeeplinkExecuted(
	// 						`UTIL_BASE64_TO_IMAGE,${base64data},my-image`
	// 					);
	// 					// return;
	// 				} else if (
	// 					window &&
	// 					window.webkit &&
	// 					window.webkit.messageHandlers &&
	// 					window.webkit.messageHandlers.onDeeplinkExecuted
	// 				) {
	// 					window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
	// 						`UTIL_BASE64_TO_IMAGE,${base64data},my-image`
	// 					);
	// 				} else {
	// 				var link = document.createElement('a');
	// 				document.body.appendChild(link);
	// 				link.download = 'Poster.png';
	// 				link.href = canvas.toDataURL('image/png');
	// 				link.target = '_blank';
	// 				link.click();
	// 				}
	// 			};
	//
	// 		});
	// 	});
	// }

	const downloadBoardImage = () => {
		var userCertificate = document.getElementById(imageBlob);
		userCertificate.style.width = userCertificate.clientWidth + "px"
		userCertificate.style.height = userCertificate.clientHeight + "px"
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		html2canvas(userCertificate, { scale: 2 }, { allowTaint: true }).then(
			function (canvas) {
				canvas.toBlob((blob) => {
					var reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = function () {
						var base64data = reader.result;
						base64data = window.btoa(base64data);
						let DeepLink = {
							screen: "UTIL_BASE64_TO_IMAGE",
							paramOne: `${base64data}`,
							paramTwo: "",
							paramTracking: "CertificateDownloaded",
							paramThree: "",
							paramSource: "",
						};
						if (window && window.mobile && window.mobile.exceuteDeeplink) {
							window.mobile.exceuteDeeplink(JSON.stringify(DeepLink));
							return;
						}
						else if (
							window &&
							window.webkit &&
							window.webkit.messageHandlers &&
							window.webkit.messageHandlers.onDeeplinkExecuted
						) {
							window.webkit.messageHandlers.onDeeplinkExecuted.postMessage(
								`UTIL_BASE64_TO_IMAGE,${base64data},my-image`
							);
						} else {
							var link = document.createElement('a');
							document.body.appendChild(link);
							link.download = 'Poster.png';
							link.href = canvas.toDataURL('image/png', 1.0);
							link.target = '_blank';
							link.click();
						}
					};
				});
			}
		);
	};


	useEffect(() => {
		handleConvertToBlob();
	}, [base64Data, imageBlob]);

	return (
		<>
			<div className={show ? 'certificate-layout show' : 'certificate-layout'}>
				<div className="layout-header">
					<h4>{tutorEndConfig.text?.certificate_drawer_title || 'Course Certificate'}</h4>
					<button onClick={() => {setDrawer(false)}}>
						<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/cross-dark-icon-img.png" alt="close" width={24}/>
					</button>
				</div>
				<div className="layout-body">
					{image && image?.length ? (
						<>
							<img src={image} crossOrigin="anonymous" alt="img"/>
							<h4>{tutorEndConfig.text?.certificate_unlocked_message || 'Congratulations! You have unlocked this certificate'}</h4>
						</>
					):
					<div className="loading-box">Loading</div>
					}

				</div>
				<div className="layout-footer">
					<button onClick={downloadBoardImage}>
						<img
							src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/downlaod-certificate-img.png"
							width={16}/>
						Download
					</button>
					<button onClick={shareLinkAppHandler}>
						<img
							src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/share-certificate-img.png"
							width={16}/>
						Share
					</button>
				</div>
			</div>
		</>
	);
};

export default BottomCard;

